import type { ObjectDetailsState } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-details.tsx';
import type { Action } from '@atlassian/react-sweet-state';
import type { InsightObjectViewState, ContainerProps } from '../../../../common/types/index.tsx';

/**
 * Internal only action to perform a delta update on the in-memory
 * representation of the current object.
 */
export const updateObjectState =
	(
		updatedProperties: Partial<ObjectDetailsState>,
		setUpdatedTime = true,
	): Action<InsightObjectViewState, ContainerProps> =>
	({ getState, setState }) => {
		const { objectDetails } = getState();
		if (!objectDetails) return;
		const updatedTime = setUpdatedTime ? new Date().toISOString() : objectDetails.updated;
		setState({
			objectDetails: {
				...objectDetails,
				// Manually set the 'updated' property to 'now' as the endpoint
				// used to update an attribute doesn't return this information.
				// Depending on network conditions, this should be accurate to
				// within a few seconds.
				updated: updatedTime,
				// Update remaining properties after 'updated' so it can be
				// overriden (in case of full object fetch)
				...updatedProperties,
			},
		});
	};
